module.exports = __webpack_public_path__ + "img/Songs for Pierre Chuvin.31cfbead.jpg";